/** Authenticated subjects enter only their own workspace; anonymous visitors enter the public site. */
export function rootEntryForSubject(subjectType: string | null | undefined): string {
  if (subjectType === 'TENANT') return '/workbench'
  if (subjectType === 'OPERATOR') return '/ops/recharges'
  if (subjectType === 'FORWARDER') return '/fwd/settlement'
  return subjectType == null ? '/home' : '/login'
}

/** A caller-controlled redirect may only stay inside the authenticated role's route family. */
export function entryAfterLogin(subjectType: string, requested: unknown): string {
  const fallback = rootEntryForSubject(subjectType)
  if (typeof requested !== 'string' || !requested.startsWith('/') || requested.startsWith('//')) return fallback
  if (subjectType === 'TENANT') {
    return /^\/(?!ops(?:\/|$)|fwd(?:\/|$)|tasks(?:\/|$)|work(?:\/|$)|drafts(?:\/|$)|login$|register$|home$)/.test(requested)
      ? requested : fallback
  }
  if (subjectType === 'OPERATOR') return /^\/ops(?:\/|$)/.test(requested) ? requested : fallback
  if (subjectType === 'FORWARDER') {
    return /^(?:\/fwd(?:\/|$)|\/tasks(?:\/|$)|\/work(?:\/|$)|\/drafts(?:\/|$)|\/fwd-settlement(?:\/|$))/.test(requested)
      ? requested : fallback
  }
  return fallback
}
